<template>
<div class="">
    <div  v-for="(block, key) in blocks" :key="`block_${key}`"  class="mb-2 row gx-1">
        <div class="col-5">
            <input type="text" :name="`items[${key}][name]`" v-model="block.name" class="form-control" id="" placeholder="例）その他" min="50" max="9999999">
        </div>
        <div class="form-check col-6 d-flex align-items-center">
            <div class="pe-2">￥</div>
            <input type="text" :name="`items[${key}][price]`" v-model="block.price" class="form-control" id="" placeholder="XX,000" min="50" max="9999999">
        </div>
    </div>

    <div class="mb-4" @click="addBlock"  v-if="Object.keys(blocks).length < max">
        <buton class="btn btn-outline-primary">＋ 自由項目を追加する</buton>
    </div>

</div>
</template>

<script>
export default {
    props: {
        errors: {
            type: Object,
            default: () => {
                return {}
            }
        },
        old: {
            type: Array,
            default: [""]
        },
        items: {
            type: Array,
            default: []
        },
        max: {
            type: Number,
            default: 2
        },
    },
    mounted() {
        if(this.items.length == 0) {
             this.addBlock()
        } else {
            this.blocks = this.items
        }
    },
    data() {
        return {
            baseData : {
                id : null,
                name : '',
                price  : '',
                offset: 0,
            },
            radioBaseData: {
                id : null,
                name : '',
            },
            blocks: [],
        }
    },
    methods: {
        addBlock() {
            if (this.blocks.length <= 10) {
                var copy = Object.assign({}, this.baseData)
                this.blocks.push(copy)
            }
        },
        // 選択肢削除
        deleteBlock(index) {
            this.blocks.splice(index, 1)
        },
    }
}
</script>
